import Vue from 'vue'
import Vuex from 'vuex'
import $ from 'jquery'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    selectedTitle: 0,
    selectedTabItem: 0,
  },
  mutations: {
    select(state,params) {
      console.log(params.index)
      state.selectedTitle = params.index;
      // state.selectedTabItem = params.tabItem;
    },
    changeIndex(state,tabItem) {
      state.selectedTabItem = tabItem;

    },
  },
  actions: {
    // 选择标题
    chooseTitle(content,params) {
      content.commit('select',params);
    },

    // 选择导航栏
    chooseTabItem(content,tabItem) {
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/js/store.js